const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXoX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 252 252",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1414.23,854.342)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,404.409,-2299.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.74363,0.74363,-0.707107,0.707107,1774.07,-349.311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905.06,1695C905.06,1670.16 885.886,1650 862.27,1650C838.653,1650 819.48,1670.16 819.48,1695L819.48,1923.99C819.48,1948.83 838.653,1968.99 862.27,1968.99C885.886,1968.99 905.06,1948.83 905.06,1923.99L905.06,1695Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.74363,-0.74363,0.707107,0.707107,-784.945,933.109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905.06,1695C905.06,1670.16 885.886,1650 862.27,1650C838.653,1650 819.48,1670.16 819.48,1695L819.48,1923.99C819.48,1948.83 838.653,1968.99 862.27,1968.99C885.886,1968.99 905.06,1948.83 905.06,1923.99L905.06,1695Z",
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXoX);
export default __webpack_public_path__ + "static/media/xo_x.1c6ae038aaea51515c442244893db153.svg";
export { ForwardRef as ReactComponent };